// extracted by mini-css-extract-plugin
export default {"archive-button":"styles_archive-button__zSLLD"};